import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import style from "./selectPoc.module.scss";
import { BeneficiaryGrp } from "../benficiaryGrp/BeneficiaryGrp";
import { Button } from "../../atoms/button/Button";
import POCForm from "../getPocData/POCForm";
import { useSelectPoc } from "../../../hooks/useSelectPoc/UseSelectPoc";
import { usePocForm } from "../../../hooks/usePocForm/UsePocForm";
import { AgentScript } from "../../atoms/agentScript/AgentScript";
import { Flex } from "antd";

export const SelectPoc = () => {
  const {emContacts,handleSelectPoc,selectedPoc,openPocForm,handlePocForm,showSavePoc,setShowSavePoc,handleSavePoc,isPocSaved}=useSelectPoc();
  const {onFinish,onFinishFailed,validateMessages,pocName,pocNumber,handlePocInputChange}=usePocForm(handlePocForm, setShowSavePoc);
  // console.log('pocNumber---selectPoc:', pocNumber)
  return (
    <>
      <BackgroundWrapper>
        <Container className={style.wrapper}>
          <Container>
            <Flex className={style.labelRow}>
              <Text text="Point Of Contact" className={style.title} />
              <AgentScript
                text='"To coordinate everything smoothly, will you continue as the point of contact, or would you like to assign someone else?"'
                className={style.mobileOnly}
              />
            </Flex>
            <AgentScript
              text='"To coordinate everything smoothly, will you continue as the point of contact, or would you like to assign someone else?"'
              className={style.desktopOnly}
            />
          </Container>
          {emContacts.length ? (
            <>
              <BeneficiaryGrp
                column={3}
                gap={1}
                className={""}
                options={emContacts}
                selectedValue={selectedPoc}
                onChange={handleSelectPoc}
              />
            </>
          ) : (
            <></>
          )}
        </Container>
        {
          openPocForm && <div style={{ marginTop: "2em" }}>
            <Flex className={style.labelRow}>
              <Text text="Add POC Details" className={style.question} />
              <AgentScript
                text="May I have the name and mobile number of the person we should coordinate with?"
                className={style.mobileOnly}
              />
            </Flex>
            <AgentScript
                text="May I have the name and mobile number of the person we should coordinate with?"
                className={style.desktopOnly}
              />
            <POCForm onFinish={onFinish} onFinishFailed={onFinishFailed} validateMessages={validateMessages} pocName={pocName} pocNumber={pocNumber} handlePocInputChange={handlePocInputChange} showSavePoc={showSavePoc} handleSavePoc={handleSavePoc} isPocSaved={isPocSaved} />
          </div>
        }
            <Button className={style.btn} text={openPocForm?"Close":"Add Poc"} onClick={handlePocForm}/>
        {selectedPoc && (
          <Container>
            <AgentScript text='"Thank you. We will proceed to assist."' />
          </Container>
        )}
      </BackgroundWrapper>
    </>
  );
};
